module.exports = __webpack_public_path__ + "media/assets/icon-pen-9993bbc8968238ebccb7152febad04c1e4a77f5b63813300c54837e7450b9601.png";